import { useEffect, useState } from 'react';

import { Option } from 'types';

import { SelectMotives, pickMotive } from 'data/selectMotives.data';

import * as S from './Select.styles';
import { StyledSelectProps } from './Select.styles';

type SelectProps = {
  value?: string | Option;
  name: string;
  className?: string;
  label?: string;
  options?: Option[];
  motive?: SelectMotives;
  onChange: (e: any) => void; // eslint-disable-line
  defaultValue?: Option;
  disabled?: boolean;
  isSearchable?: boolean;
  menuPlacement?: 'auto' | 'top' | 'bottom';
} & StyledSelectProps;

const defaultProps: Partial<SelectProps> = {
  label: undefined,
  className: undefined,
  motive: 'default',
  defaultValue: undefined,
  disabled: false,
  isSearchable: true,
  menuPlacement: 'auto',
};

export function Select(props: SelectProps): React.ReactElement {
  const {
    name,
    scale,
    label,
    className,
    options,
    onChange,
    motive,
    value,
    defaultValue,
    disabled,
    isSearchable,
    menuPlacement,
  } = {
    ...defaultProps,
    ...props,
  };

  const [selectedValue, selectedValueSet] = useState<Option>();

  useEffect(() => {
    if (value) {
      selectedValueSet(value as Option);
    }
  }, [value]);

  return (
    <S.Container scale={scale} className={className}>
      {label ? <S.Label>{label}</S.Label> : null}

      <S.Select
        menuPlacement={menuPlacement}
        onChange={onChange}
        value={selectedValue}
        options={options}
        defaultValue={defaultValue}
        styles={pickMotive(motive!)}
        name={name}
        isDisabled={disabled}
        isSearchable={isSearchable}
      />
    </S.Container>
  );
}
